import { createReducer } from '@reduxjs/toolkit';

import getCompatibilityYearGroup, {
  setCompatibilityYearGroup
} from '../../thunks/Compatibility/getCompatibilityYearGroup';

const initialState = {
  loading: false,
  error: '',
  yearGroup: [],
};

const getCompatibilityYearGroupReducer = createReducer(initialState, {
  [getCompatibilityYearGroup.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getCompatibilityYearGroup.fulfilled]: (state, { payload: { data, refresh } }) => ({
    ...state,
    loading: false,
    ...(refresh ? { yearGroup: [data] } : { yearGroup: [...state.yearGroup, ...data] }),
  }),
  [setCompatibilityYearGroup]: (state, { payload }) => ({
    ...state,
    yearGroup: payload
  }),
  [getCompatibilityYearGroup.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getCompatibilityYearGroupReducer;
